export const LEADER_TEXT = 'LEADER';
export const REVEAL_TEXT = 'Reveal';
export const REVEAL_ON_TEXT = 'Reveal On';
export const FOLDED_TEXT = 'Folded';
export const DISCARD_ONE_TEXT = 'DISCARD ONE';
